module.exports = __webpack_public_path__ + "img/Weights-table.c3f1e4eb.png";